import styled from 'styled-components'

export const Form = styled.form`
  > p {
    margin: 3rem 0;
    color: #898989;
  }

  > button {
    height: 48px;
    width: 100%;
    margin-bottom: 3rem;
    border-radius: 50px;
    border: none;
    background: #1F35B5;
    color: #FFFFFF;
    transition: background 0.3s;

    &:hover {
      background: #3650E5;
    }
  }
`

export const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 10px;
`

export const BlockContactWrapper = styled(BlockWrapper)`
  margin-top: 30px;

  .subtitle {
    margin-top: '5px';
    color: '#898989';
  }
`